import {I18nIndividual as GedcomIndividual} from "../model/gedcom-individual"
import {I18nFamily as GedcomFamily} from "../model/gedcom-family"

/* ------------------------------------------------------------------------------------------------------------------ */
/* VALIDATE PIPELINE                                                                                                  */
/* ------------------------------------------------------------------------------------------------------------------ */

/**
 * Individual or tab error with their location.
 */
export class ConverterError extends Error {
    rowType: typeof GedcomIndividual | typeof GedcomFamily  // To which Creator tab the error applies to
    entityId: string
    rowId?: number

    constructor(message: string, rowType: typeof GedcomIndividual | typeof GedcomFamily, entityId: string, rowId?: number) {
        super(message)
        this.rowType = rowType
        this.entityId = entityId
        this.rowId = rowId
    }
}

export class InvalidId extends ConverterError {}
export class DuplicatedId extends ConverterError {}
export class MissingMandatoryField extends ConverterError {}

export class MissingSpouse extends ConverterError {}
export class DuplicatedSpouse extends ConverterError {}
export class MissingHusband extends ConverterError {}
export class MissingWife extends ConverterError {}

export class MissingOneParent extends ConverterError {}
export class ParentIsSelf extends ConverterError {}
export class DuplicatedParent extends ConverterError {}
export class MissingFamily extends ConverterError {}
export class UnlinkedIndividual extends ConverterError {}

export class InvalidDateFormat extends ConverterError {}

/* ------------------------------------------------------------------------------------------------------------------ */
/* IMPORT                                                                                                             */
/* ------------------------------------------------------------------------------------------------------------------ */

export class ImportError extends Error {}

/**
 * Bundle of errors.
 */
export class ValidationErrors extends Error {
    errors: ConverterError[]
    constructor(errors: ConverterError[], message: string) {
        super(message)
        this.name = "ImportError"
        this.errors = errors
    }
}